import apiServices from "services/RequestHandler";
import { getStringFromLocalStorage } from "utils/localStore";

async function get_user() {
  try {
    const token = getStringFromLocalStorage("token") as string;
    if (!token) return;
    const user = await apiServices.getFromApi(
      `/customers/get-my-profile`,
      "user"
    );
    return user;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
}

/* eslint-disable no-restricted-globals */
self.onmessage = async function (e) {
  const { type } = e.data;
  let result;

  try {
    switch (type) {
      case "GET_USER":
        result = await get_user();
        break;

      default:
        throw new Error("Unknown worker message type");
    }

    self.postMessage({ success: true, result });
  } catch (error: any) {
    self.postMessage({ success: false, error: error.message });
  }
};

export {};
